// extracted by mini-css-extract-plugin
export default {"wrapper":"branding-success-modal_wrapper__7UxVl","button":"branding-success-modal_button__fXiGJ","opacity-transition":"branding-success-modal_opacity-transition__ctgE3"};